import { Box, Button, Center, Flex, Grid, HStack, Img, Text, VStack } from "@chakra-ui/react";
import * as htmlToImage from 'html-to-image';
import QRCode from "qrcode-react";
import React, { useEffect, useRef, useState } from "react";
import Loader from "react-loader-spinner";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useAuth } from "../../plugins/CookieAuthPlugin";
import { KhMonth, toAbsoluteUrl, toKhNumber } from "../../utils/helper";
import { translation } from "./translation";

export default function ScanSuccess() {
  const Result = JSON.parse(localStorage.getItem("qr-code"));
  const isEn = JSON.parse(localStorage.getItem("isEn")) || false;
  const history = useHistory();
  const contentRef = useRef(null);
  const { user, logout } = useAuth();
  const text = translation(isEn);
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (Result)
      localStorage.removeItem('visit_angkor_scan_form_qrcode');
    // eslint-disable-next-line
  }, [])
  const handleDownload = () => {
    setLoading(true);
    if (contentRef.current) {
      htmlToImage.toBlob(contentRef.current, { pixelRatio: 2 })
        .then(function (blob) {
          // Create a temporary anchor element to trigger the download
          const link = document.createElement('a');
          link.download = `Visit-Angkor-ETicket-${Result.visitorCode}.png`; // Set the filename for the downloaded image
          link.href = URL.createObjectURL(blob);
          link.click();
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  const convertDateEn = () => {
    const dateString = Result?.datetimeScan;
    if (!dateString) return "";
    const date = new Date(dateString);
    const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
    return formattedDate;
  };

  useEffect(() => {
    user && logout();
  }, [user, logout]);

  return (
    <Center h="93vh" w="100vw">
      <Box w={{ xl: "30vw", lg: "40vw", md: "50vw", sm: "100%", base: "100%" }} h="100%">
        <Center w="100%" h="80%" bg={`url(${toAbsoluteUrl("/assets/white-bg.svg")}) center / cover no-repeat`} overflow="hidden" px={{ base: "5px", sm: "10px" }} justifyContent="center">
          {Result ? (
            <VStack w="100%" h="100%" bgColor="red.500 " justifyContent="center">
              <Center fontSize="170%" fontFamily="moul" textAlign="center" color="red.900" w="100%">
                {text.headerTitle.on}<br />{text.headerTitle.un}
              </Center>
              <Center fontSize="160%" w="85%" bgColor="red.500" h="15%" color="white" fontFamily="moul" bg={`url(${toAbsoluteUrl("/assets/bg-button.svg")}) center / contain no-repeat`}>
                {!isEn ? toKhNumber(Result.numberOfPeople) : Result.numberOfPeople} {(Result.numberOfPeople < 2 && isEn) ? text.person_1 : text.person}
              </Center>
              <Box ref={contentRef} px="5px">
                <Flex bgColor="red.900" rounded="lg" mb="10px" p="3" justifyContent="center" alignItems="center" bg={`url(${toAbsoluteUrl("/assets/bg-banner.svg")}) center / contain no-repeat`}>
                  <Box w="50%" id="ut-qr">
                    <Flex pos={"relative"} bg={"white"} p="1.5" alignItems={"center"} justifyContent={"center"}>
                      <QRCode value={Result.visitorCode} level="M" />
                    </Flex>
                  </Box>
                  <Grid color="white" w="50%" ml="10px" lineHeight={{ lg: "200%" }} >
                    <Text fontSize={{ base: "13px", sm: "12px" }}>{text.boxInfo.province} ៖ {Result.province.label}</Text>
                    <Text fontSize={{ base: "13px", sm: "12px" }}>
                      {text.boxInfo.member} ៖ {!isEn ? toKhNumber(Result?.numberOfPeople || 0) : Result?.numberOfPeople || 0} {(Result.numberOfPeople < 2 && isEn) ? text.person_1 : text.person}
                    </Text>
                    <Text fontSize={{ base: "13px", sm: "12px" }}>{text.boxInfo.time} ៖ {Result.duration.label}</Text>
                    <Text fontSize={{ base: "13px", sm: "12px" }}>{text.boxInfo.purpose} ៖ {Result.purpose.label}</Text>
                    <Text fontSize={{ base: "13px", sm: "12px" }}>{text.boxInfo.date} ៖ {!isEn ? toKhNumber(KhMonth(Result.datetimeScan, "dd", "mm", "yyyy")) : convertDateEn()}</Text>
                  </Grid>
                </Flex>
              </Box>
              <Center fontSize="160%" h="15vh" fontFamily="moul" textAlign="center" color="red.900">
                {text.information.on}<br />{text.information.un}
              </Center>
            </VStack>
          ) : (
            <Center fontSize="170%" fontFamily="moul" height={"40vh"} textAlign="center" color="red.900">
              {text.noData}
            </Center>
          )}
        </Center>
        <Center>
          <VStack spacing="15px" w="100%">
            <VStack>
              <Text fontSize=".8rem">{text.clickDownload}</Text>
              <HStack>
                <a href="https://apps.apple.com/us/app/visit-angkor/id6465895919">
                  <Button minW="140px"><Img pos={"absolute"} src={toAbsoluteUrl("/assets/AppStore.svg")} /></Button>
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.udaya.visit_angkor">
                  <Button minW="140px"><Img pos={"absolute"} src={toAbsoluteUrl("/assets/GooglePlay.svg")} /></Button>
                </a>
              </HStack>
            </VStack>
            <Button w="90%" borderRadius={"10px"} bg={"#663333"} color={"white"} fontFamily={!isEn && "moul"} colorScheme="none"
              onClick={() => { Result ? handleDownload() : history.goBack() }}>
              {loading ? (
                <Loader type="ThreeDots" color="#fff" height={40} width={40} />) : (
                Result ? text.downloadPng : text.back)}
              <Img pos={"absolute"} right={"0"} src={toAbsoluteUrl("/assets/flower.svg")} />
              <Img pos={"absolute"} left={"0"} transform={"rotate(180deg)"} src={toAbsoluteUrl("/assets/flower.svg")} />
            </Button>
          </VStack>
        </Center>
      </Box >
    </Center >
  );
}
